import axios from 'axios';

const routing = axios.create({
  baseURL: 'https://routing.openstreetmap.de/routed-car/route/v1/driving',
});

export default routing;
